/**
 * Highlight the searchValue and return the highlighted text node
 * @param {any} searchValue - Search value
 * @param {any} text - Text content
 * @returns {any} The highlighted text node
 */
const HighlightText = (searchValue: string | null, text: string): React.ReactNode => {
  if (!searchValue) return text;

  const regex = new RegExp(`(${searchValue})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? (
      <span key={index} className="highlight">
        {part}
      </span>
    ) : (
      part
    ),
  );
};

export default HighlightText;
